(function () {
    'use strict';

    angular.module('edit')
        .controller('EditController', editController);

    editController.$inject = ['$scope', 'FilterService', '$timeout', 'editService', 'editConfigService',
        'DataService', 'GalleryService', 'DocumentService', 'NotesService', 'dialogService', 'userService', 'SharedState', '$window'];
    function editController($scope, FilterService, $timeout, editService, editConfigService,
        DataService, GalleryService, DocumentService, NotesService, dialogService, userService, SharedState, $window) {

        $scope.listMaximized = true;
        $scope.fromCoordsError = {};
        $scope.toCoordsError = {};
        function activate() {

            if (editService.obj !== null) {
                $scope.keliuPrieziurosObjektas = editService.obj;
                editService.obj = null;

                NotesService.resetNotes();
                NotesService.obj = angular.copy($scope.keliuPrieziurosObjektas);
                if (angular.isDefined(NotesService.obj.id)) {
                    NotesService.loadNotes();
                }
                $scope.note = {
                    noteText: null,
                    noteType: NotesService.getKTTITypeId(),
                    notesTypes: DataService.getNotesType()
                };

                if (angular.isDefined($scope.keliuPrieziurosObjektas.id)) {
                    $scope.disableEdit = !(userService.getPermissions().editAll
                        || (userService.getPermissions().edit && $scope.keliuPrieziurosObjektas.createdByCurrentUser));

                }
                if (angular.isDefined($scope.keliuPrieziurosObjektas.id)) {
                    $scope.disableEditUser = !(userService.getPermissions().edit && $scope.keliuPrieziurosObjektas.createdByCurrentUser);

                }

                $scope.disableSeenByLakd = !userService.getPermissions().seenByLakd;
                $scope.disableResolveDate = isResolveDateDisabled();

                if ($scope.keliuPrieziurosObjektas.kelioId != null
                    // if creating object from map then tarnybos and padaliniai are undefined and therefore needs to resolve lists
                    && !$scope.keliuPrieziurosObjektas.tarnybos && !$scope.keliuPrieziurosObjektas.padaliniai) {
                    resolveLists();
                }

                if ($scope.keliuPrieziurosObjektas.apziurosData) {
                    $scope.keliuPrieziurosObjektas.apziurosData = new Date($scope.keliuPrieziurosObjektas.apziurosData);
                }
                if ($scope.keliuPrieziurosObjektas.sprendimoData) {
                    $scope.keliuPrieziurosObjektas.sprendimoData = new Date($scope.keliuPrieziurosObjektas.sprendimoData);
                }

                $scope.loadHistory();
            } else {
                $scope.keliuPrieziurosObjektas = {
                    /*init data*/
                    apziurosData: new Date()
                };
            }
            $scope.regions = _.orderBy(editService.getWithSelected($scope.keliuPrieziurosObjektas.regionai, DataService.getRegions()), 'pavadinimas');
            $scope.roadServices = _.orderBy(editService.getWithSelected($scope.keliuPrieziurosObjektas.tarnybos, DataService.getRoadServices()), 'pavadinimas');
            $scope.masteries = _.orderBy(editService.getWithSelected($scope.keliuPrieziurosObjektas.meistrijos, DataService.getMasteries()), 'pavadinimas');
            $scope.violations = _.orderBy(editService.getWithSelected($scope.keliuPrieziurosObjektas.pazeidimai, DataService.getViolations()), 'pazeidimas');
            $scope.status = DataService.getStatus();
            $scope.workTypes = DataService.getWorkTypes();
            $scope.aprasymasTexts = DataService.getDescriptionTexts();
            $scope.currentTab = 0;
            $scope.notEmpty = $scope.keliuPrieziurosObjektas.id !== undefined && $scope.keliuPrieziurosObjektas.id !== null;
            $scope.statusConfig = editConfigService.statusMap;

            if (!$scope.keliuPrieziurosObjektas.apziurosData) {
                $scope.keliuPrieziurosObjektas.apziurosData = new Date();
            }

            if ($scope.keliuPrieziurosObjektas.defektoStatusas === undefined) {
                DataService.getStatus().forEach(function (element) {
                    if (element.lowValue == editConfigService.defaultStatusLowValue) {
                        $scope.keliuPrieziurosObjektas.defektoStatusasLowValue = element.lowValue;
                        $scope.keliuPrieziurosObjektas.defektoStatusas = element.meaning;
                    }
                })
            }

            $scope.localLang = editService.getMultiselectTranslations();
            $scope.options = editService.getDatepickerOptions();

            if ($scope.keliuPrieziurosObjektas.cameFromMap) {
                $scope.handleFromCoordsChange();
            }
        }

        $scope.loadHistory = function () {
            editService.getHistory($scope.keliuPrieziurosObjektas.id).then(function (response) {
                $scope.history = response.data;
            }, function () { });
        }

        $scope.selectRoad = function (data) {
            if (data) {
                $scope.keliuPrieziurosObjektas.kelioNumeris = data.originalObject.numeris;
                $scope.keliuPrieziurosObjektas.kelioPavadinimas = data.originalObject.pavadinimas;
                $scope.keliuPrieziurosObjektas.kelioId = data.originalObject.id;
                $scope.objKelias = data.originalObject;
                $scope.keliuPrieziurosObjektas.kmNuo = $scope.objKelias.kmNuo;
                $scope.keliuPrieziurosObjektas.kmIki = $scope.objKelias.kmIki;
                $scope.maxKm = $scope.objKelias.kmIki;
                $scope.minKm = $scope.objKelias.kmNuo;
                resolveFromCoords();
                resolveToCoords();
                resetToCoordsErrors();
                resetFromCoordsErrors();
                resolveLists();
            } else {
                $scope.keliuPrieziurosObjektas.kelioNumeris = null;
                $scope.keliuPrieziurosObjektas.kelioPavadinimas = null;
                $scope.keliuPrieziurosObjektas.kelioId = null;
                $scope.objKelias = null;
            }

        };

        $scope.handleFromKmChange = _.debounce(function() {
            resetFromCoordsErrors();
            resolveFromCoords();
            resolveLists();

            if (!$scope.$$phase) {
                $scope.$apply();
            }
        }, 300);

        $scope.handleToKmChange = _.debounce(function() {
            resetToCoordsErrors();
            resolveToCoords();
            resolveLists();

            if (!$scope.$$phase) {
                $scope.$apply();
            }
          }, 300);

        $scope.handleFromCoordsChange = function () {
            if (editService.coordsInExtent($scope.keliuPrieziurosObjektas.xnuo, $scope.keliuPrieziurosObjektas.ynuo)) {
                editService.resolveRoad($scope.keliuPrieziurosObjektas.xnuo, $scope.keliuPrieziurosObjektas.ynuo).success(function (road) {
                    if (road.kelionr == $scope.keliuPrieziurosObjektas.kelioNumeris) {
                        $scope.keliuPrieziurosObjektas.kmNuo = editService.round(road.km, 2);
                        $scope.fromCoordsError.wrongRoad = false;
                    } else {
                        $scope.fromCoordsError.wrongRoad = true;
                        $scope.keliuPrieziurosObjektas.kmNuo = null;
                        $scope.fromCoordsError.roadNr = road.kelionr;
                    }
                    $scope.keliuPrieziurosObjektas.fromDistanceToRoad = editService.round(
                        editService.distanceBetweenPoints(
                            $scope.keliuPrieziurosObjektas.xnuo,
                            $scope.keliuPrieziurosObjektas.ynuo,
                            road.x,
                            road.y),
                        1);
                    resolveLists();
                    resolveAddress();
                });
            } else {
                resetFromCoordsErrors();
            }
        }

        $scope.handleToCoordsChange = function () {
            $scope.toCoordsError.wrongRoad = false;
            if (editService.coordsInExtent($scope.keliuPrieziurosObjektas.xiki, $scope.keliuPrieziurosObjektas.yiki)) {
                editService.resolveRoad($scope.keliuPrieziurosObjektas.xiki, $scope.keliuPrieziurosObjektas.yiki).success(function (road) {
                    if (road.kelionr == $scope.keliuPrieziurosObjektas.kelioNumeris) {
                        $scope.toCoordsError.wrongCoords = false;
                        $scope.keliuPrieziurosObjektas.kmIki = editService.round(road.km, 2);
                    } else {
                        $scope.toCoordsError.wrongRoad = true;
                        $scope.keliuPrieziurosObjektas.kmIki = null;
                        $scope.toCoordsError.roadNr = road.kelionr;
                    }
                    $scope.keliuPrieziurosObjektas.toDistanceToRoad = editService.round(
                        editService.distanceBetweenPoints(
                            $scope.keliuPrieziurosObjektas.xiki,
                            $scope.keliuPrieziurosObjektas.yiki,
                            road.x,
                            road.y),
                        1);
                    resolveLists();
                });
            } else {
                resetToCoordsErrors();
            }
        }

        //////////////////////////////////////

        function isResolveDateDisabled() {
          var disableEdit = $scope.disableEdit;
          var resolveDateEditForKDRecs = userService.getPermissions().resolveDateEditForKD;
          var resolveDateEdit = userService.getPermissions().resolveDateEdit;

          if (disableEdit || (!resolveDateEditForKDRecs && !resolveDateEdit)) {
            return true;
          }

          if ($scope.keliuPrieziurosObjektas.darbuRusis === 'KD') {
            return !resolveDateEditForKDRecs;
          } else {
            return !resolveDateEdit;
          }

        }

        function resolveFromCoords() {
            editService.resolveCoordinates($scope.keliuPrieziurosObjektas.kelioNumeris, $scope.keliuPrieziurosObjektas.kmNuo)
                .success(function (data) {
                    $scope.keliuPrieziurosObjektas.xnuo = editService.round(data.x, 2);
                    $scope.keliuPrieziurosObjektas.ynuo = editService.round(data.y, 2);
                    resolveAddress();
                });
        }

        function resolveToCoords() {
            editService.resolveCoordinates($scope.keliuPrieziurosObjektas.kelioNumeris, $scope.keliuPrieziurosObjektas.kmIki)
                .success(function (data) {
                    $scope.keliuPrieziurosObjektas.xiki = editService.round(data.x, 2);
                    $scope.keliuPrieziurosObjektas.yiki = editService.round(data.y, 2);
                });
        }

        function resolveAddress() {
            editService.resolveAddress($scope.keliuPrieziurosObjektas.xnuo, $scope.keliuPrieziurosObjektas.ynuo).success(function (addresses) {
                var nearest = { distance: Number.MAX_VALUE };
                angular.forEach(addresses.response.docs, function (address) {
                    if (address.distance && address.distance < nearest.distance) {
                        nearest = address;
                    }
                });
                $scope.keliuPrieziurosObjektas.adresas = nearest.name + ' ' + nearest.description;
            });
        }

        function resetFromCoordsErrors() {
            $scope.fromCoordsError.wrongRoad = false;
            $scope.fromCoordsError.wrongCoords = false;
            $scope.keliuPrieziurosObjektas.fromDistanceToRoad = 0;
        }

        function resetToCoordsErrors() {
            $scope.toCoordsError.wrongRoad = false;
            $scope.toCoordsError.wrongCoords = false;
            $scope.keliuPrieziurosObjektas.toDistanceToRoad = 0;
        }

        function resolveLists() {
            editService.resolveRoadDivisions($scope.keliuPrieziurosObjektas)
                .then(function (response) {
                    selectListElements($scope.regions, response.data.regions);
                    selectListElements($scope.roadServices, response.data.roadServices);
                    selectListElements($scope.masteries, response.data.masteries);
                });
        }

        function selectListElements(listElements, selectedElemets) {
            angular.forEach(listElements, function (listElement) {
                listElement.selected = selectedElemets.includes(listElement.id);
            });
        }

        $scope.getMyLocationFrom = function () {
            editService.getMyLocation(function (position) {
                editService.transformCoordinates(position).success(function (coords) {
                    editService.resolveRoad(coords.geometries[0].x, coords.geometries[0].y).success(function (userRoad) {
                        editService.resolveRoadByNumber(userRoad.kelionr).success(function (road) {
                            if ($scope.keliuPrieziurosObjektas.kelioId !== road[0].id) {
                                dialogService.confirm('Kelias kuriame esate yra kitas, nei prieš tai buvęs, ar norite pakeisti kelią?', '', 'Pakeisti')
                                    .then(function () {
                                        $scope._changePlaceFrom(road[0], userRoad, true);
                                    });
                            } else {
                                $scope._changePlaceFrom(road[0], userRoad, false);
                            }
                        });
                    });
                });
            });
        };

        $scope.getMyLocationTo = function () {
            editService.getMyLocation(function (position) {
                editService.transformCoordinates(position).success(function (coords) {
                    editService.resolveRoad(coords.geometries[0].x, coords.geometries[0].y).success(function (userRoad) {
                        editService.resolveRoadByNumber(userRoad.kelionr).success(function (road) {
                            if ($scope.keliuPrieziurosObjektas.kelioId !== road[0].id) {
                                dialogService.confirm('Kelias kuriame esate yra kitas, nei prieš tai buvęs, ar norite pakeisti kelią?', '', 'Pakeisti')
                                    .then(function () {
                                        $scope._changePlaceTo(road[0], userRoad, true);
                                    });
                            } else {
                                $scope._changePlaceTo(road[0], userRoad, false);
                            }
                        });
                    });
                });
            });
        };

        $scope.save = function () {
            $scope.savingInProgress = true;

            function showError(message) {
                $scope.savingInProgress = false;
                return dialogService.error(message);
            }

            $scope.keliuPrieziurosObjektas.regionai = [];
            if ($scope.selectedRegions && $scope.selectedRegions.length > 0) {
                angular.forEach($scope.selectedRegions, function (item) {
                    $scope.keliuPrieziurosObjektas.regionai.push(item.id);
                });
            } else {
                return showError('Regionų sąrašas yra tuščias!');
            }

            $scope.keliuPrieziurosObjektas.tarnybos = [];
            if ($scope.selectedServices && $scope.selectedServices.length > 0) {
                angular.forEach($scope.selectedServices, function (item) {
                    $scope.keliuPrieziurosObjektas.tarnybos.push(item.id);
                });
            } else {
                return showError('Tarnybų sąrašas yra tuščias!');
            }

            $scope.keliuPrieziurosObjektas.meistrijos = [];
            if ($scope.selectedMasteries && $scope.selectedMasteries.length > 0) {
                angular.forEach($scope.selectedMasteries, function (item) {
                    $scope.keliuPrieziurosObjektas.meistrijos.push(item.id);
                });
            } else {
                return showError('Meistrijų sąrašas yra tuščias!');
            }

            $scope.keliuPrieziurosObjektas.pazeidimai = [];
            if ($scope.selectedViolations && $scope.selectedViolations.length > 0) {
                angular.forEach($scope.selectedViolations, function (item) {
                    $scope.keliuPrieziurosObjektas.pazeidimai.push(item.id);
                });
            } else {
                return showError('Defektų grupių sąrašas yra tuščias!');
            }

            var kmNuo = parseFloat($scope.keliuPrieziurosObjektas.kmNuo);
            var kmIki = parseFloat($scope.keliuPrieziurosObjektas.kmIki);

            if (!kmNuo) {
              return showError('Neįvestas kilometras Nuo');
            }

            if ($scope.minKm > kmNuo || kmNuo > $scope.maxKm ) {
              $scope.savingInProgress = false;
              return showError('Kilometras Nuo turi būti skaičius nuo ' + $scope.minKm + ' iki ' + $scope.maxKm);
            }

            if (kmIki && ($scope.minKm > kmIki || kmIki > $scope.maxKm) ) {
              return showError('Kilometras Iki turi būti skaičius nuo ' + $scope.minKm + ' iki ' + $scope.maxKm);
            }

            if (kmIki && kmNuo > kmIki) {
                return showError('Kilometras Nuo, viršija kilometrą Iki');
            }

            if ($scope.keliuPrieziurosObjektas.fromDistanceToRoad > editConfigService.maxDistance
                || $scope.keliuPrieziurosObjektas.toDistanceToRoad > editConfigService.maxDistance
                || $scope.fromCoordsError.wrongRoad
                || $scope.toCoordsError.wrongRoad) {
                return showError('Atstumas tarp kelio ir taško viršija ' + editConfigService.maxDistance + 'm, arba taškas(-ai) nėra prie nurodyto kelio.');
            }

            editService.save($scope.keliuPrieziurosObjektas)
                .success(function (data) {
                    $scope.clear();
                    DataService.refreshData(FilterService.filters);
                    editService.obj = data;
                    activate();
                    dialogService.success('Objektas išsaugotas.', '');
                })
                .error(function (data, status) {
                    if(status === 400 && data.message) {
                        dialogService.error(data.message);
                        return;
                    }
                    dialogService.error(status === 403 ? 'Nepakanka teisių redaguoti šį objektą' : 'Įvyko klaida saugant objektą');
                })
                .finally(function() {
                    $scope.savingInProgress = false;
                });
        };


        $scope.onWindowResize = function () { //handle window resizing (make sure, that the image does not overflow under the floating list)
            var bottom = document.getElementById('gallery-bottom').getBoundingClientRect().bottom;
            document.getElementById('gallery-modal-dialog').style.height = window.innerHeight - 200 + 'px';
            if ($scope.listMaximized)
                bottom -= bottom * 0.25; //subtract the thumb container height
            else bottom -= 25; //bottom position - padding
            var imagedropBoxRect = document.getElementById('image-display').getBoundingClientRect();
            if (imagedropBoxRect.top == 0)
                document.getElementById('image-display').style.maxHeight = window.innerHeight - 200 + 'px';
            else
                document.getElementById('image-display').style.maxHeight = (bottom - imagedropBoxRect.top - 20) + 'px';
        };

        $scope.clear = function () {
            $scope.selectedRegions = [];
            $scope.selectedRoadServices = [];
            $scope.selectedMasteries = [];
            $scope.selectedMeans = [];
        };

        $scope.getAutocompleteUrl = function () {
            return editConfigService.roadSearch;
        }

        $scope.confirmRemove = function () {
            dialogService.confirm('Ar tikrai norite ištrinti šitą defektą?').then(function () {
                editService.remove($scope.keliuPrieziurosObjektas.id).success(function () {
                    SharedState.turnOff('edit');
                    DataService.refreshData(FilterService.filters);
                }).error(function (data, status) {
                    dialogService.error(status === 403 ? 'Nepakanka teisių' : 'Įvyko klaida trinant objektą');
                });
            });
        };

        $scope._changePlaceFrom = function (road, userRoad, clearOther) {
            $scope.$broadcast('angucomplete-alt:changeInput', 'road', road.numeris + ' ' + road.pavadinimas);
            $scope.selectRoad({ originalObject: road });
            $timeout(function () {
                $scope.keliuPrieziurosObjektas.xnuo = userRoad.x;
                $scope.keliuPrieziurosObjektas.ynuo = userRoad.y;
                $scope.keliuPrieziurosObjektas.kmNuo = Math.round(userRoad.km*1000) / 1000;

                if (clearOther) {
                    $scope.keliuPrieziurosObjektas.xiki = null;
                    $scope.keliuPrieziurosObjektas.yiki = null;
                    $scope.keliuPrieziurosObjektas.kmIki = null;
                }
            }, 500);
        };

        $scope._changePlaceTo = function (road, userRoad, clearOther) {
            $scope.$broadcast('angucomplete-alt:changeInput', 'road', road.numeris + ' ' + road.pavadinimas);
            $scope.selectRoad({ originalObject: road });
            $timeout(function () {
                $scope.keliuPrieziurosObjektas.xiki = userRoad.x;
                $scope.keliuPrieziurosObjektas.yiki = userRoad.y;
                $scope.keliuPrieziurosObjektas.kmIki = Math.round(userRoad.km*1000) / 1000;

                if (clearOther) {
                    $scope.keliuPrieziurosObjektas.xnuo = null;
                    $scope.keliuPrieziurosObjektas.ynuo = null;
                    $scope.keliuPrieziurosObjektas.kmNuo = null;
                }
            }, 500);
        };

        $scope.uploadPicture = function (element) {
            GalleryService.uploadImages($scope.keliuPrieziurosObjektas.id, element, null, function () {
                $scope.$broadcast('refreshGallery');
                $scope.loadHistory();
            });
        };

        $scope.uploadDocument = function (element) {
            DocumentService.uploadDocuments($scope.keliuPrieziurosObjektas.id, element, null, false);
            $scope.loadHistory();
        }

        $scope.saveNote = function () {
            var obj = {
                tipasId: $scope.note.noteType,
                tekstas: $scope.note.noteText,
                kelioPrieziurosObjektoId: $scope.keliuPrieziurosObjektas.id
            };
            NotesService.save(obj).then(function () {
                $scope.loadHistory();
            });
            NotesService.obj.pastabuKiekis++;
            $scope.note.noteText = null;
            $scope.$broadcast('reloadNotes');
        }

        $scope.changeStatusConfig = function (statusValue) {
            editService.changeStatus({ obj: $scope.keliuPrieziurosObjektas.id, lowValue: statusValue }).then(function (response) {
                $scope.keliuPrieziurosObjektas.defektoStatusasLowValue = response.data.defektoStatusasLowValue;
                $scope.keliuPrieziurosObjektas.defektoStatusas = response.data.defektoStatusas;
                DataService.refreshData(FilterService.filters);
                $scope.loadHistory();
            }, function (response) {
                dialogService.error(response.data)
            });
        }

        $scope.setIssprendimoData = function (days, months) {
            var issprendimoData = new Date($scope.keliuPrieziurosObjektas.apziurosData);

            issprendimoData.setDate(issprendimoData.getDate() + days);
            issprendimoData.setMonth(issprendimoData.getMonth() + months);

            $scope.keliuPrieziurosObjektas.sprendimoData = issprendimoData;
        }

        $scope.addTextForAprasymas = function (text) {
            $scope.keliuPrieziurosObjektas.aprasymas =
                $scope.keliuPrieziurosObjektas.aprasymas ? $scope.keliuPrieziurosObjektas.aprasymas + ' ' + text : text;
        }

        $scope.changeWorkType = function (selectedViolations) {
          if($scope.keliuPrieziurosObjektas.darbuRusis !== 'KD') {
            angular.forEach(selectedViolations, function(el) {
              if (el.aprasymas === 'nelegali veikla') {
                $scope.keliuPrieziurosObjektas.darbuRusis = 'KD';
              }
            });
          }
        }

        $scope.updateResolveDatePermissions = function () {
          $scope.disableResolveDate = isResolveDateDisabled();
        }

        $scope.openUrl = function (url) {
            if(url) {
                $window.open(url, '_blank');
            }
        }

        activate();

    }
})();
